export const CREATOR_DECLINE_REASON_OPTIONS = [
  { value: "Not a good fit", label: "Not a good fit" },
  { value: "Audience mismatch", label: "Audience mismatch" },
  { value: "Budget not aligned", label: "Budget not aligned" },
  { value: "Other", label: "Other" },
];
